import * as React from 'react';
import clsx from 'clsx';

export const GracePeriodCard: React.FC = () => (
  <div className={clsx('mb-6 w-full rounded-20 p-6', 'bg-grace-period-gradient')}>
    <h4 className='mb-2 font-sans text-20 font-bold leading-27 text-brand-800'>
      30-Day Grace Period
    </h4>
    <p className='font-sans text-16 font-normal leading-20 text-brand-800'>
      Your digital echo will be stored for 30 days in case you want to come back.
      <br className='hidden md:block' />
      After this period, all data will be permanently deleted.
    </p>
  </div>
);
